<template>
    <Layout>
        <PageHeader :title="title" :items="items" :backButton="true" :prevRoutePath="backUrl"/> 
        <div class="row">
            <div class="col-lg-12 col-sm-12 mb-3">
                <div class="card p-4">
                    <div class="media">
                        <div class="avatar-sm mr-3">
                            <span class="avatar-title rounded-circle bg-light text-primary border-primary font-size-22">
                                <i class="bx bx-user bx-md"></i>
                            </span>
                        </div>
                        <div class="media-body">
                            <h5 class="mt-3">{{this.$t('education.mahasiswa-detail')}}</h5>
                        </div>
                    </div>

                    <div v-if="loading" class="row mt-4 mx-auto">
                        <div class="text-center p-5">
                             <div class="spinner-border text-secondary" role="status"></div>
                            <p>{{$t('education.get-data')}} ..</p>
                        </div>
                    </div>

                    <div>
                    <div class="row mt-4">
                        <div class="col-sm-12">
                            <table class="table table-bordered px-2">
                            <tbody>
                                <tr>
                                <td width="20%">
                                    {{ $t('education.name') }}
                                </td>
                                <td>
                                <b>{{mhs.nm_pd}}</b>
                                </td>
                            </tr>
                            <tr>
                                <td width="20%">
                                    NIM
                                </td>
                                <td>
                                {{mhs.nipd}}
                                </td>
                            </tr>
                            <tr>
                                <td width="20%">
                                  {{ $t('education.perguruan-tinggi') }}
                                </td>
                                <td>
                                {{mhs.namapt}}
                                </td>
                            </tr>
                            <tr>
                                <td width="20%">
                                 {{ $t('education.jenjang') }}
                                </td>
                                <td>
                                {{mhs.namajenjang}}
                                </td>
                            </tr>
                                
                            <tr>
                                <td width="20%">
                                  {{ $t('education.program-studi') }}
                                </td>
                                <td>
                                {{mhs.namaprodi}}
                                </td>
                            </tr>
                                <tr>
                                <td width="20%">
                                  {{ $t('education.jenis-kelamin') }}
                                </td>
                                <td>
                                {{mhs.jk}}
                                </td>
                            </tr>
                            <tr>
                                <td width="20%">
                                 {{ $t('education.semester-awal') }}
                                </td>
                                <td>
                                {{mhs.mulai_smt}}
                                </td>
                            </tr>
                                <tr>
                                <td width="20%">
                                 {{ $t('education.status-awal') }}
                                </td>
                                <td>
                                {{mhs.nm_jns_daftar}}
                                </td>
                            </tr>
                            <tr v-if="mhs.nama_pt_asal">
                                <td width="20%">
                                 {{ $t('education.nama-pt-awal') }}
                                </td>
                                <td>
                                {{mhs.nama_pt_asal}}
                                </td>
                            </tr>
                                <tr v-if="mhs.nm_prodi_asal">
                                <td width="20%">
                                 {{ $t('education.prodi-asal') }}
                                </td>
                                <td>
                                {{mhs.nm_prodi_asal}}
                                </td>
                            </tr>
                                <tr v-if="mhs.ket_keluar">
                                <td width="20%">
                                {{ $t('education.status') }}  
                                </td>
                                <td>
                                {{mhs.ket_keluar}}
                                </td>
                                </tr>
                                <tr v-if="mhs.tgl_keluar">
                                <td width="20%">
                                {{ $t('education.tanggal-lulus') }} 
                                </td>
                                <td>
                                <span v-if="mhs.tgl_keluar">{{formatDate(mhs.tgl_keluar)}} </span>
                                </td>
                               </tr>
                                <tr v-if="mhs.no_seri_ijazah">
                                <td width="20%">
                                {{ $t('education.nomer-ijazah') }} 
                                </td>
                                <td>
                                {{mhs.no_seri_ijazah}}
                                </td>
                                </tr>
                                <tr v-if="mhs.sert_prof">
                                <td width="20%">
                                {{ $t('education.sertifikasi-profesi') }}
                                </td>
                                <td>
                                {{mhs.sert_prof}}
                                </td>
                                </tr>
                                <tr>
                                <td width="20%">
                                {{ $t('education.target-profil') }}
                                </td>
                                <td>
                                <div class="form-group row">
                                    <div class="col-5">
                                        <b-form-tags
                                                id="tags-with-dropdown"
                                                v-model="relation"
                                                no-outer-focus
                                            >
                                                <template
                                                v-slot="{ tags, disabled, removeTag }"
                                                >
                                                <ul
                                                    v-if="tags.length > 0"
                                                    class="list-inline d-inline-block mb-2"
                                                >
                                                    <li
                                                    v-for="(tag, index) in tags"
                                                    :key="index"
                                                    class="list-inline-item mb-2 align-center"
                                                    float="center"
                                                    >
                                                    <b-form-tag
                                                        @remove="removeTag(tag)"
                                                        :title="tag"
                                                        :disabled="disabled"
                                                        variant="primary"
                                                    >
                                                        <div class="team justify-content-centerml-5">
                                                        <a
                                                            href="javascript: void(0);"
                                                            class="team-member d-inline-block"
                                                        >
                                                            <img
                                                            :src="url_image + JSON.parse(tag).image"
                                                            class="rounded-circle avatar-xs m-1"
                                                            alt
                                                            />
                                                        </a>
                                                        </div>
                                                        {{ JSON.parse(tag).name }}
                                                    </b-form-tag>
                                                    </li>
                                                </ul>

                                                <b-dropdown
                                                    v-if="relation.length !== 1"
                                                    size="sm"
                                                    variant="outline-secondary"
                                                    block
                                                    menu-class="w-100"
                                                >
                                                    <template #button-content>
                                                    {{ $t("wizard.form.button.relation_profile") }}
                                                    </template>
                                                    <b-dropdown-form @submit.stop.prevent="() => {}">
                                                    <b-form-group
                                                    
                                                        label-for="tag-search-input"
                                                        label-cols-md="auto"
                                                        class="mb-0"
                                                        label-size="sm"
                                                        :description="searchDesc"
                                                        :disabled="disabled"
                                                    >
                                                        <b-form-input
                                                        v-on:keyup="
                                                            searchTarget != ''
                                                            ? (show = true)
                                                            : (show = false)
                                                        "
                                                        v-model="searchTarget"
                                                        id="tag-search-input"
                                                        type="search"
                                                        size="sm"
                                                        autocomplete="off"
                                                        ></b-form-input>
                                                    </b-form-group>
                                                    </b-dropdown-form>
                                                    <b-dropdown-divider>
                                                    
                                                    </b-dropdown-divider>

                                                    <b-dropdown-item-button
                                                    v-show="show"
                                                    v-for="(option, index) in availableOptions"
                                                    :key="index"
                                                    @click="onOptionClick(option)"
                                                    >
                                                    {{ option.name }}
                                                    </b-dropdown-item-button>
                                                    <b-dropdown-text
                                                    v-if="availableOptions.length === 0"
                                                    >
                                                    {{ $t("wizard.form.validation.not_match2") }}
                                                    </b-dropdown-text>
                                                </b-dropdown>
                                                </template>
                                        </b-form-tags>
                                    </div>
                                    </div>
                                </td>
                                </tr>
                                <tr>
                                <td width="20%">
                                </td>
                                <td>
                                    <div>
                                    <button class="xbadge btn btn-success  mr-1 mb-1 px-2 text-white" :disabled="relation.length !== 1 " @click="AddTargetCitizen">{{ $t('education.simpan-education') }}</button>  
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                            </table>
                        </div>
                        <div class="col-sm-12 text-center" v-if="dnfp && dnf && !userList">
                            <p class="text-secondary p-5">{{ $t('overview.table.all.dnf') }}</p>
                        </div>
                    </div>
                    </div>
                   </div>
            </div>
        </div>
    </Layout>
</template>

<script>
import Vue from "vue";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import moment from 'moment';
import EducationService from "@/helpers/education.service";
import PhoneService from "@/helpers/phone.service.js";
import TargetService from "@/helpers/target-profile.service";
import SocmedService from "@/helpers/socmed.service";
import GroupService from "@/helpers/group.service";
import Swal from "sweetalert2";

export default {
    page: {
        title: "Education Search",
        meta: [{ name: "description", content: appConfig.description }]
    },
    components: { Layout, PageHeader },
    data() {
        return {
            backUrl: "/education-search",
            items: [
                {
                text: "Dashboard",
                href: "/"
                },
                 {
                text:  this.$t('education.education-search'),
                href: "/education-search"
                },
                {
                text: this.$t('education.mahasiswa-detail'),
                active: true
                }
            ],
            id: this.$route.params.id,
            url_image:process.env.VUE_APP_BASE_API_URL + "target/image-project?name=",
            loadingGrup: false,
            loading: false,
            loadinglist: false,
            search: false,
            searchKey: "",
            searchTarget:"",
            mhs: "",
            x:{ "total": { "value": 0, "relation": "eq" }, "hits": []},
            relation:[],
            options: [],
            dnf: false,
            dnfp: false,
            is_spam:"",
            search: false,
            title: this.$t('education.mahasiswa-detail')
        }
    },
     computed:{
        rows() {
          return this.tableData.length;
        },

        criteria() {
        return this.searchTarget.trim().toLowerCase();
        },
        
        availableOptions() {
        const criteria = this.criteria;
        let element = [];
        try {
            for (let i = 0; i < this.relation.length; i++) {
            element.push(JSON.parse(this.relation[i]).id);
            }
        } catch (e) {
            element = [];
        }
        const options = this.options.filter(
            (opt) => element.indexOf(opt.id) === -1
        );
        this.show = false;
        if (criteria) {
            this.show = true;
            return options.filter((opt) =>
            opt.name.toLowerCase().includes(criteria)
            );
        }
        return options;
        },
        searchDesc() {
        if (this.criteria && this.availableOptions.length === 0) {
            return this.$t("wizard.form.validation.not_match1");
        }
        return "";
        },
        validFormat() {
        if (this.validformat != null) {
            if (this.validformat) {
            return "is-valid";
            } else {
            return "is-invalid";
            }
        }
        },
    },
    methods:{
         getNama() {
                var data = {
                    "nama_mahasiswa": this.id,
               };
               console.log(data);
                EducationService.getMahasiwa(data)
                .then((response) => {
                    const res = response.data.output.data_umum;
                    this.mhs = res;
                    this.dnf = false
                    this.loading = false;  
                })
                .catch((err) => {
                    console.log(err);
                    this.search = false;
                    this.loading = false;  
                    this.dnf = true;
                    
                });
        },

         listProfile(){
            TargetService.getTargetBy()
            .then((response) => {
                response.data.data.forEach((val) => {
                const opt = {
                    name: val.title,
                    id: val.id_target,
                    image: val.image_project,
                };
                this.options.push(opt);
                });
            })
            .catch((err) => {
                console.log(err);
            });
        },

        onOptionClick(option) {
            this.relation.push({
            name: option.name,
            id: option.id,
            image: option.image,
        });
        this.show = false;
        this.search = "";
        },

        AddTargetCitizen(){
            let data = {
                "id_target":  JSON.parse(this.relation).id,
                "nipd" : this.mhs.nipd,
                "nm_pd" : this.mhs.nm_pd,
                "namapt" : this.mhs.namapt,
                "namajenjang" : this.mhs.namajenjang,
                "namaprodi" : this.mhs.namaprodi,
                "jk" : this.mhs.jk,
                "reg_pd" : this.mhs.reg_pd,
                "mulai_smt" :this.mhs.mulai_smt,
                "nm_jns_daftar" : this.mhs.nm_jns_daftar,
                "nm_pt_asal" : this.mhs.nm_pt_asal,
                "nm_prodi_asal" : this.mhs.nm_prodi_asal,
                "ket_keluar" : this.mhs.ket_keluar,
                "tgl_keluar" : this.mhs.tgl_keluar,
                "no_seri_ijazah" : this.mhs.no_seri_ijazah,
                "sert_prof" : this.mhs.sert_prof,
                "link_pt" : this.mhs.link_pt,
                "link_prodi" : this.mhs.link_prodi,
            }
            console.log(data);
            EducationService.SaveEducation(data)
            .then( response => {
                Vue.swal({
                    position: "top-end",
                    icon: "success",
                    title: response.data.message,
                    showConfirmButton: false,
                    timer: 1500
                });
                  this.$router.push({ name:'project-overview', params: { id: JSON.parse(this.relation).id }})
            })
            .catch(err => {
                console.log(err);
            });
        },
        toFixed(value){
            return value.toFixed(0);
        },
        formatDate(value){
            return moment(value).format("YYYY-MM-DD");
        },
    },
     beforeMount(){
        this.listProfile()
    },
    mounted(){
        this.getNama();
        this.availableOptions;
    }
};
</script>

<style scoped>
.loading{
    padding-top:20%;
    padding-bottom:20%;
}
</style>